import {FC} from 'react';
//formik
import {useFormikContext} from 'formik';
//form configuration
import {AuctionFormValues} from '../formConfiguration';
//mui
import {Box} from '@mui/material';
//constants
import {ADD_ITEM, CANCEL, FORM, SAVE_CHANGES} from '@/utils/constants';
//components
import TableFooterActions from '@/shared/components/Table/TableFooterActions';
import AddItemForm from './AddItemForm';
import AuctionDonors from './AuctionDonors';
//styles
import {formContentStyle} from './FormContent.styles';

interface FormContentProps {
	onCloseModal: () => void;
	edit?: boolean;
}

const FormContent: FC<FormContentProps> = ({onCloseModal, edit}) => {
	const {submitForm} = useFormikContext<AuctionFormValues>();

	const handleSubmitForm = () => {
		submitForm();
	};

	return (
		<Box component={FORM} sx={formContentStyle.form}>
			<AddItemForm />

			<AuctionDonors />

			<TableFooterActions
				titleButtonPrev={CANCEL}
				titleButtonNext={edit ? SAVE_CHANGES : ADD_ITEM}
				onClickButtonNext={handleSubmitForm}
				onClickButtonPrev={onCloseModal}
			/>
		</Box>
	);
};

export default FormContent;
